export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Bank",
  headline: "Unlimited Transactions with Zero Fees",
  description:
    "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees",
  buttonLabel: "Get Started",
  imgStart: false,
  img: require("../../images/svg-1.svg").default,
  alt: "Car",
  dark: true,
  //for buttons
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headline: "Log into your account at any time",
  description:
    "We have you covered no matter where you are located. All you need is an internet connection and a phone or computer.",
  buttonLabel: "Learn More",
  imgStart: true,
  img: require("../../images/svg-2.svg").default,
  alt: "Piggy Bank",
  dark: false,
  //for buttons
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "about",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join our Team",
  headline: "Creating an Account is Extremely Easy",
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you're ready to go.",
  buttonLabel: "Start Now",
  imgStart: false,
  img: require("../../images/svg-3.svg").default,
  alt: "Paper",
  dark: false,
  //for buttons
  primary: false,
  darkText: true,
};
